export const colors = {
  yellow: "#FFDC00",
  green: "#2ECC40",
  black: "#444",
  gray: "#EEE",
};

export const EVENTS = {
  start: "start",
  retry: "retry",
  end: "end",
};